import { FormikContext } from 'formik'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { RoleSettings } from './role-settings'
import { useFormik } from '../../../../common/hooks/formik'
import { ModalBottom } from '../../../../common/ui/modal/modal-bottom'
import { PureInput } from '../../../../common/ui/pure-input/pure-input'
import { Permission } from '../../../../entities/permissions/types/permission.types'
import { AddRoleModalValidationSchema } from '../../../users/users/validators/add-role-modal-validation-schema'
import { getRoleFormInitialValues } from '../helpers/get-role-form-initial-values'
import { getRolePermissions } from '../helpers/get-role-permissions'
import { PermissionSection, Role } from '../types/roles-page-types'

interface RoleModalProps {
  name?: string | null
  onCancel: () => void
  onSubmit: (role: { name: string; permissions: Record<string, boolean> }) => void
  open: boolean
  role: Role | null
  permissions: Permission[]
}

export const RoleModal = ({ open, onCancel, onSubmit, name = null, permissions, role }: RoleModalProps) => {
  const { t } = useTranslation()
  const [convertedPermisson, setConvertedPermisson] = useState<PermissionSection[]>([])

  useEffect(() => {
    setConvertedPermisson(getRolePermissions(permissions, t))
  }, [permissions])

  const formik = useFormik({
    initialValues: getRoleFormInitialValues(permissions, role),
    validationSchema: AddRoleModalValidationSchema(),
    enableReinitialize: true,
    onSubmit: (values) => {
      onSubmit(values)
      onCancel()
    },
  })

  const handleSubmit = async () => {
    const errors = await formik.validateForm()
    if (!Object.values(errors).length) {
      onSubmit(formik.values)
    }
  }

  return (
    <ModalBottom
      cancelText={t('rolesPage.addRoleModal.cancelText')}
      okText={!!role ? t('common.update') : t('rolesPage.addRoleModal.okText')}
      onCancel={() => {
        formik.resetForm()
        onCancel()
      }}
      onOk={handleSubmit}
      open={open}
      title={name ? name : t('rolesPage.addRoleModal.title')}
    >
      <FormikContext.Provider value={formik as any}>
        <form
          className="row"
          onSubmit={formik.handleSubmit}
        >
          <div className="col-12 col-sm-6 mb-3">
            <p className="mb-1">{t('rolesPage.addRoleModal.nameLabel')}</p>
            <PureInput
              {...formik.getFieldProps('name')}
              error={formik.errors.name as any}
              moduleStyle="mb-3"
              placeholder={t('rolesPage.addRoleModal.inputPlaceholder')}
            />
          </div>
          <RoleSettings
            getFieldProps={formik.getFieldProps}
            permissions={convertedPermisson}
          />
        </form>
      </FormikContext.Provider>
    </ModalBottom>
  )
}
